module.exports = __webpack_public_path__ + "img/three2Green.bc7f4279.jpg";